import planificationEscl from '../../../locales/es-CL/planification.json';
import planificationEsmx from '../../../locales/es-MX/planification.json';
import planificationEsco from '../../../locales/es-CO/planification.json';
import planificationEnus from '../../../locales/en-US/planification.json';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import Multiselect from 'vue-multiselect';
import showAlert from '../../../alert/alertHandler';
import showConfirmation from '../../../confirmation/confirmationHandler';
import showOperationDetail from '../operationDetailModal/operationDetailModalHandler';
import RouteDetailMap from '../../../components/RouteDetailMap.vue';
import ProgressBar from '../../../components/ProgressBar.vue';
import BuscadorDirecciones from '@/components/global/buscador-direcciones/buscador-direcciones.vue';
import AddOperations from '@/components/AddOperations.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import Vue from 'vue';
import Container from 'typedi';
import { v1 as uuidv1 } from 'uuid';
import moment from 'moment';
import axios from 'axios';
import LogService from '../../../services/LogService';
import OperationService from '../../../services/OperationService';

export default {
  name: 'OperationProcess',
  components: {
    AddOperations,
    Multiselect,
    VueCtkDateTimePicker,
    RouteDetailMap,
    BuscadorDirecciones,
    GoogleMapsApiLoader,
    ProgressBar,
  },
  i18n: {
    messages: {
      'es-CL': {
        planification: planificationEscl,
      },
      'es-MX': {
        planification: planificationEsmx,
      },
      'es-CO': {
        planification: planificationEsco,
      },
      'en-US': {
        planification: planificationEnus,
      },
    },
  },
  props: {
    planificationId: {
      type: String,
      default: null,
    },
    planificationState: {
      type: String,
      default: null,
    },
    planificationOngoing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cancelado: false,
      isDeletePreparing: false,
      actualStep: 'operation',
      selectedAllOperations: false,
      selectedAllOperationsPending: false,
      selectedAllOperationsIntegration: false,
      validDate: true,
      dismissCountDown: 0,
      dismissSecs: 3,
      dataAccess: null,
      optimizationOutput: null,
      optimizationInput: null,
      isMainPageBussy: false,
      isSearchBussy: false,
      isFilterShown: false,
      isFilterClicked: false,
      isFilterApplied: false,
      form: {
        executionDate: '',
        planificationName: null,
        initHour: '',
        endHour: '',
      },
      formOperationEditSpot: {
        addressComplement: null,
        neighborhood: null,
        name: null,
        address: null,
        lat: null,
        lon: null,
        idSpotTemporal: null,
        sender: null,
        documents: [],
      },
      formOperation: {
        addressComplement: null,
        neighborhood: null,
        name: null,
        address: null,
        lat: null,
        lon: null,
        idSpotTemporal: null,
        sender: null,
        documents: [],
        tags: null,
        volume: null,
        weight: null,
        money: null,
        startHour: null,
        endHour: null,
        spotServiceTime: null,
        contact: null,
        phone: null,
        email: null,
      },
      formPendingOperation: {
        date: {
          start: moment(new Date().setDate(new Date().getDate() - 14)).format('YYYY-MM-DD'),
          end: moment(new Date()).format('YYYY-MM-DD'),
        },
        state: [],
        integration: 'none',
      },
      formIntegrationOperation: {
        date: {
          start: null,
          end: null,
        },
        state: [
          {
            name: 'No planificadas',
            state: 'unplanned',
          },
        ],
        integrations: [],
      },
      currentSortBy: null,
      optimizationBody: null,
      planIsOngoing: false,
      forceClose: false,
      showLoadOperationManual: false,
      showLoadOperationMassive: false,
      showLoadOperationPending: false,
      showLoadOperationIntegration: false,
      filterOperation: null,
      filterTypeOperation: [],
      filterOperationState: [],
      filterVehicles: [],
      filterDrivers: [],
      filterOperationTemp: null,
      filterTypeOperationTemp: [],
      filterOperationStateTemp: [],
      filterVehiclesTemp: [],
      filterDriversTemp: [],
      operationsFilter: [],
      operations: [],
      spotsTemporal: [],
      spotsTemporalData: [],
      checkedOperations: [],
      checkedOPerationsPending: [],
      checkedOPerationsIntegrations: [],
      tags: [],
      pendingOperations: [],
      integrationsOperations: [],
      senderList: [],
      itemNames: [],
      distanceMatrixManual: {
        operations: [],
        origins: [],
        destinations: [],
      }, //Nuevos destinos en modo edición por si se desea hacer de forma manual
      gapi: null,
      logService: null,
      operationService: null,
      idOperationJob: 0,
      totalOperationsPending: 0,
      totalOperationsIntegrations: 0,
      deletedTags: new Set(),
      addOperationClicked: false,
      currentPageOperation: 1,
      perPageOperation: 10,
      currentPageOperationPending: 1,
      currentPageOperationIntegration: 1,
      perPageOperationPending: 10,
      perPageOperationIntegration: 10,
      pageOptionsOperation: [10, 15, 20, 50, 100],
      pageOptions: [10, 15, 20, 50, 100],
      operationsMassive: [],
      filterOpPending: null,
      messageSuccess: null,
      filterOpIntegration: null,
      emptyIntegration: false,
      emptySearchDate: false,
      emptyState: false,
      isMassiveBussy: false,
      integrations: [],
      states: [
        /* {
          name: 'Todos',
          state: 'all',
        }, */
        {
          name: 'Pendientes',
          state: 'pending',
        },
        {
          name: 'No planificadas',
          state: 'unplanned',
        },
        {
          name: 'Rechazados',
          state: 'rejected',
        },
      ],
      names: [],
      actualProcess: 1,
      typeOperationOptions: [
        {
          type: 'DELIVERY',
          name: 'Entrega',
        },
        {
          type: 'COLLECTION',
          name: 'Retiro',
        },
      ],
      excelDataCreate: [
        {
          name: '(Ejemplo)Actividad 1',
          address: 'SANTA MARIA 2670, PROVIDENCIA',
          Ccityiudad: 'Santiago',
          state: 'Región Metropolitana',
          country: 'Chile',
          extraAddress: '',
          lat: '',
          lon: '',
          hourInit: '',
          hourEnd: '',
          timeActivity: '',
          contact: 'Paulina Muñoz',
          phone: '965847147',
          email: 'paulinamunoz@ejemplo.com',
          load1: '',
          load2: '',
          load3: '',
          tag: '',
        },
      ],
      excelHeaders: {
        nombre: 'Nombre operacion (Obligatorio)',
        tipoOperacion: 'Tipo de operación (Obligatorio)',
        direccion: 'Dirección  (Obligatorio)',
        ciudad: 'Ciudad  (Obligatorio)',
        estado: 'Estado  (Obligatorio)',
        pais: 'Pais  (Obligatorio)',
        neighborhood: this.$t('planification.planificationBuilder.operation.fieldNeighborhood'),
        extraDireccion: 'Dato extra dirección (Depto, Casa)',
        lat: 'Latitud',
        lon: 'Longitud',
        horarioInicial: 'Hora inicial (HH:mm)',
        horarioFinal: 'Hora final (HH:mm)',
        tiempoActividad: 'Tiempo de operacion (Por defecto: 10 min)',
        contacto: 'Persona de contacto',
        telefono: 'Teléfono de contacto',
        correo: 'Correo electrónico de contacto',
        volumen: 'Carga 1 (Volumen m3)',
        peso: 'Carga 2 (Peso kg)',
        dinero: 'Carga 3 (Dinero)',
        tag: 'Atributos',
        sender: 'Cliente',
        addinfo: 'Información adicional',
      },
      isFirstTimeBussy: true,
      namePlanification: null,
    };
  },
  beforeRouteLeave(to, from, next) {
    const allowedRoutes = [
      'OperationProcess',
      'OperationProcessNotOngoing',
      'DateAndDepotProcess',
      'DateAndDepotProcessNotOngoing',
      'ResourceProcess',
      'ResourceProcessNotOngoing',
      'RouteProcess',
      'RouteProcessNotOngoing',
      'PlanificationBuilder',
      'PlanificationBuilderNotOngoing',
    ];
    if (!allowedRoutes.includes(to.name)) {
      this.$store.commit('setMetaData', null); // Limpia los datos si no es una ruta permitida
      this.$store.commit('setInputOptimization', null);
      this.$store.commit('setOututOptimization', null);
    }
    next(); // Permite la navegación
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  async created() {
    this.isMainPageBussy = true;
    this.dataAccess = this.$store.getters.dataAccess;
    this.logService = Container.get(LogService);
    this.operationService = Container.get(OperationService);
    GoogleMapsApiLoader({
      libraries: ['places', 'marker'],
      apiKey: this.$store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    this.prepareData();
  },
  methods: {
    async prepareData() {
      //Esto es para setear los datos si es que estoy volviendo de otra vista
      const isComingFromOtherStage = this.jsonData && Object.keys(this.jsonData).length > 0;
      this.$set(this, 'form', this.jsonData.form ?? this.form);
      //Si vengo de otra vista entonces no necesito ir a
      if (isComingFromOtherStage) {
        this.$set(this, 'operations', this.jsonData.operations ?? []);
        this.spotsTemporalData = [...(this.jsonData.spotsTemporalData ?? [])];
      }

      this.tags = this.jsonData.tags ?? (await this.getTags());
      this.senderList = this.jsonData.senderList ?? (await this.getSenderList());
      this.itemNames = this.jsonData.itemNames ?? this.getItemNames();
      if (this.planificationId) {
        this.planIsOngoing = this.planificationState === 'STARTED' || this.planificationState === 'ONGOING';
        //Esta condición es si acaso vengo devolviendome de otra vista, lo que evita ir por la información de la planificación nuevamente
        if (isComingFromOtherStage) {
          this.$set(
            this,
            'distanceMatrixManual',
            this.jsonData.distanceMatrixManual || { operations: [], origins: [], destinations: [] },
          );
          const { inputOptimization, outputOptimization } = this.$store.getters;
          const inputOptimizationStr = JSON.stringify(inputOptimization || {});
          const outputOptimizationStr = JSON.stringify(outputOptimization || {});
          this.optimizationInput = JSON.parse(inputOptimizationStr);
          this.optimizationOutput = JSON.parse(outputOptimizationStr);
          const emptyList = [];
          const opsWithStatus = await this.operationService.getStatusByPlanification(emptyList, this.planificationId);
          this.updateStatusOperations(this.operations, opsWithStatus);
        } else {
          const emptyList = [];
          const opsWithStatus = await this.operationService.getStatusByPlanification(emptyList, this.planificationId);
          const planification = await this.getPlanificationData();
          this.preparedEditMode(planification, opsWithStatus);
        }
        this.checkTagsChange();
        this.namePlanification =
          this.optimizationInput && 'name' in this.optimizationInput ? this.optimizationInput.name : this.form.name;
      }
      this.applyFilter();
      this.isFirstTimeBussy = false;
      this.isMainPageBussy = false;
    },
    async getIntegrationTypes() {
      try {
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `getIntegrationTypes llamada a la api de lastmile`,
        });
        const response = await axios.get(`${this.$store.getters.urlAPI}/integration`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          let data = response.data.data;
          data = data.sort((a, b) => a.name.localeCompare(b.name));
          return data;
        }
        return [];
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getIntegrationTypes fallo ${e.message}`,
        });
        console.log(e);
        return [];
      }
    },
    //Si vuelvo a la sección de operaciones voy a actualizar si es que alguna otra operación ha sido gestionada en el tiempo transcurrido
    updateStatusOperations(operations, opsWithStatus) {
      for (let operation of operations) {
        const status = this.findStatusOperation(operation, opsWithStatus);
        operation.operationState = status;
      }
    },
    checkTagsChange() {
      // Muestra los tags que han sido desactivads o ya no estan disponibles
      let deletedTagsList = Array.from(this.deletedTags);
      if (deletedTagsList.length > 0) {
        let notValidTags = deletedTagsList.sort().join(', ') + '.';
        showAlert(
          this.$t('common.modals.warning'),
          this.$t('planification.planificationBuilder.unavailableTags') + notValidTags,
          'error',
        );
        this.deletedTags = new Set();
      }
    },
    /**
     * Metodo que elimina del listado de spots unicamente si pertenece a una sola operación
     * @param {Operation} selectedOperation
     */
    deleteSpotWithIdOperation(selectedOperation) {
      //Busco si es que hay mas operaciones con el mismo id de spot
      const multipleSameSpots = this.operations.filter((operation) => {
        if (selectedOperation.idSpotTemporal === operation.idSpotTemporal) {
          return operation;
        }
      });
      //Si solamente existe una operacion con ese spot, entonces busco el spot dentro del listado para eliminarlo
      if (multipleSameSpots && multipleSameSpots.length < 2) {
        const indice = this.spotsTemporalData.findIndex((spot) => spot.id === selectedOperation.idSpotTemporal);
        if (indice >= 0) {
          this.spotsTemporalData.splice(indice, 1);
        }
      }
    },
    async getOperationsWithStatus(listOpUuid) {
      const urlPlanification = `${this.$store.getters.urlAPI}/operation/byPlanification/${this.planificationId}`;
      try {
        this.logService.sendInfo({
          component: 'operationProcess',
          message: `getOperationsWithStatus voy a buscar las operaciones con la url ${urlPlanification}`,
        });
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.post(urlPlanification, listOpUuid, config);
        const data = response.data.data;
        data.forEach((op) => {
          if (op.state === 'NEW') {
            op.state = 'NOTHANDLED';
          }
        });
        return data;
      } catch (e) {
        this.logService.sendError({
          component: 'operationProcess',
          message: `getOperationsWithStatus fallo ${e.message}`,
        });
        console.log(e);
        return [];
      }
    },
    async getPlanificationData() {
      const urlPlanification = `${this.$store.getters.urlAPI}/planification/${this.planificationId}`;
      try {
        this.logService.sendInfo({
          component: 'operationProcess',
          message: `getPlanificationData voy a buscar la planificación con la url ${urlPlanification}`,
        });
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlPlanification, config);
        return response.data.data;
      } catch (e) {
        this.logService.sendError({
          component: 'operationProcess',
          message: `getPlanificationData fallo ${e.message}`,
        });
        console.log(e);
        return null;
      }
    },
    /**
     * metodo que a partir de la data obtenida del findById rellena la vista con todas las variables correspondientes
     * @param {Planification} planification
     */
    preparedEditMode(planification, opsWithStatus) {
      let inputOptimization = JSON.parse(planification.inputOptimization);
      this.optimizationInput = inputOptimization;
      this.optimizationOutput = JSON.parse(planification.outputOptimization);
      console.log('Preparando modo edición ', this.optimizationOutput);
      this.showLoadOperationManual = true;
      this.form.planificationName = inputOptimization.name;
      inputOptimization.operations.forEach((operation) => {
        let spot = inputOptimization.spots.find((spot) => spot.name == operation.spot);
        let tags = null;
        if (operation.tags) {
          tags = this.tags.filter((tag) => {
            if (operation.tags.includes(tag.id.toString())) {
              if (tag.enabled) {
                return tag;
              } else {
                this.deletedTags.add(tag.name);
              }
            }
          });
        }
        const status = this.findStatusOperation(operation, opsWithStatus);
        const result = this.findOperationResource(this.optimizationOutput.routes, operation);
        const auxAddress = this.buildBodySpotEditMode(spot);
        let body = {
          idOperationJob: this.idOperationJob++,
          uuid: operation.uuid,
          idSpotTemporal: operation.idSpotTemporal,
          name: operation.name,
          tags: tags,
          address: auxAddress.address,
          addressComplement: auxAddress.addressComplement,
          neighborhood: auxAddress.neighborhood,
          city: auxAddress.city,
          state: auxAddress.state,
          country: auxAddress.country,
          typeOperation: this.typeOperationOptions.find((operationType) => operationType.type == operation.type),
          lat: spot ? spot.lat : null,
          lon: spot ? spot.lon : null,
          operationState: status,
          route: result ? result.route : null,
          resource: result ? result.resource : null,
          geocodingResult: operation.extraInfo.geocodingResult,
          startHour:
            operation.spotTimeWindow && operation.spotTimeWindow.startTime
              ? moment(new Date(operation.spotTimeWindow.startTime)).format('HH:mm')
              : null,
          endHour:
            operation.spotTimeWindow && operation.spotTimeWindow.endTime
              ? moment(new Date(operation.spotTimeWindow.endTime)).format('HH:mm')
              : null,
          spotServiceTime: operation.spotServiceTime ? operation.spotServiceTime / 60 : 10,
          contact: operation.extraInfo.customerName ? operation.extraInfo.customerName : null,
          phone: operation.extraInfo.customerPhone ? operation.extraInfo.customerPhone : null,
          email: operation.extraInfo.customerEmail ? operation.extraInfo.customerEmail : null,
          additionalInfo: operation.extraInfo.additionalInfo ? operation.extraInfo.additionalInfo : null,
          idSender: operation.extraInfo.idSender ? operation.extraInfo.idSender : null,
          sender: null,
          documents: operation.extraInfo.documents ? operation.extraInfo.documents : [],
          volume: operation.volume,
          weight: operation.weight,
          money: operation.money,
        };
        if (body.idSender) {
          for (let index in this.senderList) {
            if (body.idSender == this.senderList[index].id) {
              body.sender = this.senderList[index];
            }
          }
        }
        this.operations.push(body);
      });
    },
    findStatusOperation(operation, opsWithStatus) {
      const status = 'NOTHANDLED';
      for (const opWStatus of opsWithStatus) {
        if (operation.uuid === opWStatus.uuid && opWStatus.state !== 'NEW') {
          return opWStatus.state;
        }
      }
      return status;
    },
    findOperationResource(routes, currentOperation) {
      for (let i = 0; i < routes.length; i++) {
        const route = routes[i];
        const resource = route.resources[0];

        // Verifica si la operación actual está dentro del listado de operaciones
        if (
          resource.operations.some(
            (operation) =>
              (operation.task === 'DELIVERY' || operation.task === 'COLLECTION') &&
              operation.uuid === currentOperation.uuid,
          )
        ) {
          // Retorna un objeto con extraInfo y el índice de la ruta
          return { resource: resource.extraInfo, route: `Ruta ${i + 1}` };
        }
      }

      // Si no se encuentra la operación, retorna null o un valor predeterminado
      return null;
    },
    buildBodySpotEditMode(spot) {
      //Se prepara el body de una operación
      let auxAddress = {};
      // Validacion para saber si tiene el nuevo campo de vecindario o complemento
      if (spot.extraInfo.addressComplete) {
        auxAddress = JSON.parse(spot.extraInfo.addressComplete);
      } else {
        let address = spot ? spot.extraInfo.address.split(',') : null;
        if (spot && ('hasAddressComp' in spot.extraInfo || 'hasNeighborhood' in spot.extraInfo)) {
          let hasAddressComp = spot.extraInfo.hasAddressComp;
          let hasNeighborhood = spot.extraInfo.hasNeighborhood;

          let neighborhood = null;
          let addressComplement = null;

          let lastIndex = 0;
          if (address.length == 5) {
            if (hasAddressComp) addressComplement = address ? address[1] : null;
            if (hasNeighborhood) neighborhood = address ? address[1] : null;
            lastIndex = 1;
          } else if (address.length > 5) {
            addressComplement = address ? address[1] : null;
            neighborhood = address ? address[2] : null;
            lastIndex = 2;
          }

          auxAddress = {
            address: address ? address[0] : null,
            addressComplement: addressComplement,
            neighborhood: neighborhood,
            city: address ? address[++lastIndex] : null,
            state: address ? address[++lastIndex] : null,
            country: address ? address[++lastIndex] : null,
          };
        } else {
          auxAddress = {
            address: address ? address[0] : null,
            addressComplement: address && address.length == 5 ? address[1] : null,
            neighborhood: null,
            city: address ? (address.length == 4 ? address[1] : address[2]) : null,
            state: address ? (address.length == 4 ? address[2] : address[3]) : null,
            country: address ? (address.length == 4 ? address[3] : address[4]) : null,
          };
        }
      }
      //Se prepara el body de los spots
      let spotBody = {
        id: spot.extraInfo.id,
        address: {
          lat: spot.lat,
          lon: spot.lon,
          addressComplement: auxAddress.addressComplement,
          neighborhood: auxAddress.neighborhood,
          street: auxAddress.address,
          city: auxAddress.city,
          state: auxAddress.state,
          country: {
            name: auxAddress.country,
          },
        },
      };
      this.spotsTemporalData.push(spotBody);
      return auxAddress;
    },
    async getSenderList() {
      try {
        const url = `${this.$store.getters.urlAPI}/sender?pageNum=1&pageSize=200`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(url, config);
        return response.data.data;
      } catch (e) {
        this.logService.sendError({
          component: 'operationProcess',
          message: `getSenderList fallo el obtener los senders ${e.message}`,
        });
        if (e.response.status === 404) {
          return [];
        }
        return;
      }
    },
    async getTags() {
      try {
        this.logService.sendInfo({
          component: 'operationProcess',
          message: `getTags llamada a la api de lastmile`,
        });
        this.isLoadingTag = true;
        const response = await axios.get(`${this.$store.getters.urlAPI}/tag`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.isLoadingTag = false;
        if (response.data.status) {
          return response.data.data;
        }
        return [];
      } catch (e) {
        this.logService.sendError({
          component: 'operationProcess',
          message: `getTags fallo ${e.message}`,
        });
        this.isLoadingTag = false;
        console.log(e);
        return [];
      }
    },
    async getItemNames() {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/itemData`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.itemNames = response.data.data;
      } catch (e) {
        this.logService.sendError({
          component: 'operationProcess',
          message: `getItemNames fallo el obtener los items ${e.message}`,
        });
        this.itemNames = [];
      }
    },
    async validateOperations() {
      let result = {
        isValid: true,
        isAddressValid: true,
      };
      for (const op of this.operations) {
        if (
          op.address == undefined ||
          op.address == '' ||
          op.city == undefined ||
          op.city == '' ||
          op.state == undefined ||
          op.state == '' ||
          op.country == undefined ||
          op.country == ''
        ) {
          showAlert(
            this.$t('common.modals.errorTitulo'),
            `La operacion ${op.name} no posee uno de los campos requeridos`,
            'error',
          );
          return (result.isValid = false);
        }
        if (op.geocodingResult === 'APPROXIMATE' || op.geocodingResult === 'GEOMETRIC_CENTER') {
          if (result.isAddressValid) {
            result.isAddressValid = false;
          }
        }
      }
      return result;
    },
    cleanOperations() {
      showConfirmation(
        this.$t('planification.planificationBuilder.modal.confirmDelete'),
        this.$t('planification.planificationBuilder.modal.messageDeleteOp', {
          operations: this.checkedOperations.length,
        }),
        async () => {
          this.currentSortBy = null;
          this.isMainPageBussy = true;
          //Si estoy en una planificación ya creada, entonces debo verificar que los estados de las operaciones no hayan sido modificados
          if (this.planificationId != null && this.planificationId != undefined) {
            await this.processCleaningOPeration();
          } else {
            await this.cleanOperationsAndSpots();
          }
          this.isMainPageBussy = false;
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    /**
     * Metodo se encarga de limpiar las operaciones seleccionadas verificando si su estado no paso a gestionada en el proceso de eliminación
     */
    async processCleaningOPeration() {
      let opsWStatus = [];

      //Esto se hace para no ir por todos los datos de las operaciones al back y solo traer las que quiero validar
      if (this.checkedOperations.length === this.operations.length) {
        opsWStatus = await this.operationService.getStatusByPlanification([], this.planificationId);
      } else {
        opsWStatus = await this.operationService.getStatusByPlanification(this.checkedOperations, this.planificationId);
      }
      const opsUuidSet = new Set(opsWStatus.map((op) => op.uuid));
      // ⚠️ Si falta algún uuid en la respuesta del backend, lo agregamos manualmente
      for (const uuid of this.checkedOperations) {
        if (!opsUuidSet.has(uuid)) {
          opsWStatus.push({ uuid, state: 'NOTHANDLED' });
          opsUuidSet.add(uuid); // lo añadimos también al Set para mantenerlo sincronizado
        }
      }
      //Con las operaciones traidas frescas del back, entonces vemos si podemos hacer una actualización de estados por si fueron gestionadas
      const opStatusMap = new Map(opsWStatus.map((op) => [op.uuid, op.state]));
      const newCheckedOperations = [];

      let listOperationWithChanges = [];

      this.operations.forEach((oldOp) => {
        const newState = opStatusMap.get(oldOp.uuid);
        if (newState !== undefined && oldOp.operationState !== newState) {
          console.log('Mira los estados ', newState, ', Viejo estado: ', oldOp.operationState);
          oldOp.operationState = newState;
          listOperationWithChanges.push(oldOp.name);
        }
        if (newState === 'NOTHANDLED') {
          newCheckedOperations.push(oldOp.uuid);
        }
      });
      //Vamos a dejar unicamente las operaciones que no han sido gestionadas
      this.checkedOperations = newCheckedOperations;
      //Si hay operaciones que sufrieron cambios de estado entonces mostramos el mensaje
      if (listOperationWithChanges.length > 0) {
        showAlert(
          this.$t('common.modals.warning'),
          this.$t('planification.planificationBuilder.operation.invalidActionMassDelete', {
            totalChecked: this.checkedOperations.length,
            operationNames: listOperationWithChanges.join(', '),
          }),
          'success',
        );
      }
      await this.cleanOperationsAndSpots();
    },
    //Se encarga de eliminar las operaciones y los spots vinculados a dichas operaciones, segun las operaciones seleccionadas
    async cleanOperationsAndSpots() {
      //Dejo solo las operaciones que seran eliminadas, osea solo las que son NOTHANDLED
      const checkedSet = new Set(this.checkedOperations.map((u) => u.trim()));
      //Dejo un nuevo listado de operaciones eliminadas para eliminar los spots de dichas operaciones
      const deletedOps = this.operations.filter((op) => checkedSet.has(op.uuid.trim()));
      this.spotsTemporalData = this.spotsTemporalData.filter(
        (spot) => !deletedOps.some((op) => op.idSpotTemporal === spot.id),
      );
      this.operations = this.operations.filter((op) => !checkedSet.has(op.uuid.trim()));

      this.emptyMassDeleteSelects();
      await this.applyFilter();
    },
    /**
     * Metodo que ordena el listado de operaciones segun los campos de izquierda a derecha
     * @param {*} a
     * @param {*} b
     * @returns
     */
    sortRules(a, b) {
      if (
        (a.geocodingResult === 'APPROXIMATE' || a.geocodingResult === 'GEOMETRIC_CENTER') &&
        (b.geocodingResult === 'APPROXIMATE' || b.geocodingResult === 'GEOMETRIC_CENTER')
      ) {
        return 0;
      }
      if (a.geocodingResult === 'APPROXIMATE' || a.geocodingResult === 'GEOMETRIC_CENTER') {
        return -1;
      }
      if (b.geocodingResult === 'APPROXIMATE' || b.geocodingResult === 'GEOMETRIC_CENTER') {
        return 1;
      }
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;

      if (a.typeOperation && b.typeOperation) {
        if (a.typeOperation < b.typeOperation) return -1;
        if (a.typeOperation > b.typeOperation) return 1;
      }

      if (a.address < b.address) return -1;
      if (a.address > b.address) return 1;

      return 0;
    },
    checkOperationsPlanOngoing() {
      if (this.selectedAllOperations) {
        this.checkAllOperation(this.operationsFilterComputed, this.checkedOperations);
      } else {
        this.unCheckAllOperationOngoing(this.checkedOperations);
      }
    },
    //Checkea todas las operaciones del listado que le entrego, siempre y cuando no este gestionada
    checkAllOperation(operationList, checkedOperations) {
      for (let operation of operationList) {
        if ((operation.operationState && operation.operationState === 'NOTHANDLED') || !this.planificationId) {
          //Selecciono solamente vehiculos que no estan siendo utilizados
          if (!checkedOperations.find((uuidOp) => uuidOp === operation.uuid)) {
            checkedOperations.push(operation.uuid);
          } else {
            console.log('Esta es mi operación ', operation.name, operation.uuid, operation.operationState);
          }
        }
      }
    },
    unCheckAllOperationOngoing() {
      this.selectedAllOperations = false;
      this.checkedOperations = [];
    },
    getTooltipContent(state, type) {
      if ((state && state === 'NOTHANDLED') || state === undefined) {
        if (type === 'delete') {
          return this.$t('planification.planificationBuilder.operation.delete');
        } else if (type === 'view') {
          return this.$t('planification.planificationBuilder.operation.view');
        }
        return this.$t('planification.planificationBuilder.operation.edit');
      } else {
        if (type === 'view') {
          return this.$t('planification.planificationBuilder.operation.view');
        }
        return this.$t('planification.planificationBuilder.operation.notEnabledEditOrDelete');
      }
    },
    isOperationManaged(operation) {
      return !!(operation.operationState && operation.operationState !== 'NOTHANDLED');
    },
    obtainHour(actualTimeStamp, seconds) {
      let start = new Date(actualTimeStamp).getTime() + seconds * 1000;
      const hour = moment(start).format('HH:mm');
      return hour.toString();
    },
    async addOperationManual() {
      this.addOperationClicked = true;
      if (this.formOperation.name && this.formOperation.address) {
        this.addOperationClicked = false;
        let operation = {
          uuid: uuidv1(),
          idOperationJob: this.idOperationJob++,
          name: this.formOperation.name,
          typeOperation: 'DELIVERY',
          lat: this.formOperation.lat,
          lon: this.formOperation.lon,
          addressComplement: this.formOperation.addressComplement,
          neighborhood: this.formOperation.neighborhood,
          address: this.formOperation.streetNameSimple,
          city: this.formOperation.city,
          state: this.formOperation.state,
          country: this.formOperation.country,
          sender: this.formOperation.sender,
          documents: this.formOperation.documents,
          idSpotTemporal: null,
          tags: this.formOperation.tags,
          volume: this.formOperation.volume,
          weight: this.formOperation.weight,
          money: this.formOperation.money,
          startHour: this.formOperation.startHour,
          endHour: this.formOperation.endHour,
          spotServiceTime: this.formOperation.spotServiceTime,
          contact: this.formOperation.contact,
          phone: this.formOperation.phone,
          email: this.formOperation.email,
          operationState: 'NOTHANDLED',
          resource: null,
          route: null,
        };
        //TODO Se comenta este segmento hasta analizar el caso cuando hay operaciones en el mismo spot para la edición
        /*let operationSameSpot = this.operations.filter((operation) => operation.address == this.formOperation.address);
              if (operationSameSpot.length > 0) {
                operation.idSpotTemporal = operationSameSpot.idSpotTemporal;
                operation.nameSpot = operationSameSpot[0].nameSpot;
              } else {*/
        let spotTemporal = await this.saveSpotTemporal();
        operation.idSpotTemporal = this.formOperation.idSpotTemporal;
        operation.nameSpot = spotTemporal.name;
        operation.geocodingResult = spotTemporal.geocodingResult;
        if (this.planificationId) {
          this.distanceMatrixManual.operations.push(operation);
        }
        //}
        operation.spotServiceTime = 10;
        this.operations.push(operation);
        await this.applyFilter();
        this.dismissCountDown = this.dismissSecs;
        this.cleanFormOperation();
        await this.$refs.map.cleanMarkers();
      }
    },
    async cleanFilter() {
      this.filterDriversTemp = [];
      this.filterTypeOperationTemp = [];
      this.filterVehiclesTemp = [];
      this.filterOperationStateTemp = [];

      this.filterDrivers = [];
      this.filterTypeOperation = [];
      this.filterVehicles = [];
      this.filterOperationState = [];
      await this.applyFilter();
    },
    //Sincronizo las operaciones, spots y distance matrix cuando guardo operaciones desde el componente addOperation
    syncOperationsWith(listOperations, listdistanceMatrixManual, listSpotsTemporal, type) {
      if (type === 'manual' || type === 'massive' || type == 'fromBd') {
        this.dismissCountDown = this.dismissSecs;
        this.messageSuccess =
          listOperations.length > 1
            ? this.$t('planification.planificationBuilder.operation.modalSuccessMassive')
            : this.$t('planification.planificationBuilder.operation.modalSuccess');
      }
      if (type != 'closeModal') {
        const uuidsExistentes = new Set(this.operations.map((op) => op.uuid));
        // Filtrar solo los que no estén ya en la lista
        const nuevasOperations = listOperations.filter((op) => !uuidsExistentes.has(op.uuid));
        const ultimoId = this.operations.reduce((max, op) => Math.max(max, op.idOperationJob || 0), 0);
        // Paso 2: clonar y asignar idListJob incremental a listOperations
        const newOperationsWithIds = nuevasOperations.map((op, index) => ({
          ...op,
          idOperationJob: ultimoId + index + 1,
        }));
        this.operations = [...this.operations, ...newOperationsWithIds];

        // 1. Filtrar `spotsTemporalData` por ID (evitar duplicados)
        const existingSpotIds = new Set(this.spotsTemporalData.map((spot) => spot.id));
        const newSpots = listSpotsTemporal
          .filter((spot) => spot.id != undefined && spot.id != null)
          .filter((spot) => !existingSpotIds.has(spot.id));

        // 2. Filtrar `origins` también por ID (los mismos spots)
        const existingOriginIds = new Set(this.distanceMatrixManual.origins.map((origin) => origin.id));
        const newOrigins = (listdistanceMatrixManual.origins || []).filter(
          (origin) => !existingOriginIds.has(origin.id),
        );

        // 3. Filtrar `operations` por UUID
        const existingOpUuids = new Set(this.distanceMatrixManual.operations.map((op) => op.uuid));
        const newOperations = (listdistanceMatrixManual.operations || []).filter((op) => !existingOpUuids.has(op.uuid));

        this.spotsTemporalData = [...this.spotsTemporalData, ...newSpots];
        this.distanceMatrixManual.origins = [...this.distanceMatrixManual.origins, ...newOrigins];
        this.distanceMatrixManual.operations = [...this.distanceMatrixManual.operations, ...newOperations];

        console.log('ACTUALIZANDO DISTANCE MATRIX ', this.distanceMatrixManual.operations);
      }
      //Esto implica que si estoy añadiendo operaciones es por el modal cuando una planificacion ya existe
      if (this.planificationId != null || type === 'closeModal') {
        this.$bvModal.hide('addOpsPlanExist');
      }
      this.applyFilter();
    },
    async cleanFilterText() {
      this.filterOperationTemp = null;

      this.filterOperation = null;
      await this.applyFilter();
    },
    async saveSpotTemporal() {
      try {
        const body = {
          addressComplement: this.formOperation.addressComplement,
          neighborhood: this.formOperation.neighborhood,
          address: this.formOperation.streetNameSimple,
          city: this.formOperation.city,
          state: this.formOperation.state,
          country: this.formOperation.country.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
          lat: this.formOperation.lat,
          lon: this.formOperation.lon,
        };
        this.logService.sendInfo({
          component: 'operationProcess',
          message: `saveSpotTemporal enviando la data`,
          data: body,
        });
        const response = await axios.post(`${this.$store.getters.urlAPI}/spot/createTemporal`, body, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        let ret = response.data.data;
        this.formOperation.idSpotTemporal = ret.id;
        this.spotsTemporalData.push(ret);
        if (this.planificationId) {
          this.distanceMatrixManual.origins.push({
            name: ret.id,
            lat: ret.address.lat,
            lon: ret.address.lon,
          });
        }
        console.log('respuesta del servicio spot temporales', ret);
        return ret;
      } catch (e) {
        this.logService.sendError({
          component: 'operationProcess',
          message: `saveSpotTemporal fallo el servicio ${e.message}`,
        });
        this.isMainPageBussy = false;
        console.log(e);
        return null;
      }
    },
    limitText(count) {
      return `${this.$t('planification.search.limitText')} ${count}`;
    },
    checkFilter() {
      console.log('Existe ');
    },
    async searchOperations(page, pageSize, formOperationFilter, globalList, isIntegration) {
      if (this.validSearch(formOperationFilter)) {
        let dateStamp = null;
        if (formOperationFilter.date && formOperationFilter.date.start) {
          dateStamp = new Date(formOperationFilter.date.start + ' 00:00:00').getTime();
        } else {
          dateStamp = new Date(moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00').getTime();
        }
        let dateStampEnd = null;
        if (formOperationFilter.date && formOperationFilter.date.end) {
          dateStampEnd = new Date(formOperationFilter.date.end + ' 23:59:59').getTime();
        } else {
          let endDate = new Date();
          endDate = endDate.setDate(endDate.getDate() - 14);
          dateStampEnd = new Date(moment(endDate).format('YYYY-MM-DD') + ' 23:59:59').getTime();
        }
        let url = null;
        url = `${this.$store.getters.urlAPI}/operation?pageNum=${page}&pageSize=${pageSize}`;
        formOperationFilter.state.forEach((stateTemp) => {
          url += `&state=${stateTemp.state}`;
        });
        if (isIntegration) {
          if (formOperationFilter.integrations && formOperationFilter.integrations.length > 0) {
            formOperationFilter.integrations.forEach((integration) => {
              url += `&integrations=${integration.id}`;
            });
          }
        }
        if (dateStamp != null) {
          url += `&createdFromDate=${dateStamp}`;
        }
        if (dateStampEnd != null) {
          url += `&createdToDate=${dateStampEnd}`;
        }
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `searchOperations va a buscar las operaciones con el siguiente path a la api ${url}`,
        });
        try {
          const response = await axios.get(url, {
            headers: {
              'id-client': this.$store.getters.clientId,
              Authorization: `Bearer ${this.$store.getters.accessToken}`,
            },
          });
          const data = response.data;
          if (data.status) {
            //El map se usa para que no se deba hacer un find por cada operación que traera el servicio
            let integrationsUsed = new Map();
            data.data.forEach((op) => {
              if (op.integrationType !== undefined && op.integrationType !== null && op.integrationType !== 0) {
                const valueType = integrationsUsed.get(op.integrationType);
                if (valueType) {
                  op.integration = valueType;
                } else {
                  const infoIntegration = this.integrations.find((integration) => integration.id == op.integrationType);
                  integrationsUsed.set(infoIntegration.id, infoIntegration.name);
                  op.integration = infoIntegration.name;
                }
              }
            });
            if (isIntegration) {
              data.data = data.data.sort((a, b) => this.sortRulesOps(a, b));
            }
          }
          return data;
        } catch (e) {
          this.logService.sendError({
            component: 'planificationBUilder',
            message: `searchOperations fallo el llamado para obtener operaciones ${e.message}`,
          });
          if (e.response.data.message == 'No encontrado') {
            return { data: [], paginator: 0 };
          }
          console.log(e.response.data);
        }
      } else {
        return { data: globalList, paginator: globalList.length };
      }
    },
    sortRulesOps(a, b) {
      // 1. Ordenar por fecha (ascendente)
      if (b.createdAt !== a.createdAt) {
        return b.createdAt > a.createdAt ? 1 : -1;
      }
      const nameCompare = a.name.localeCompare(b.name);
      if (nameCompare !== 0) return nameCompare;
      const integrationCompare = a.integration.localeCompare(b.integration);
      if (integrationCompare !== 0) return integrationCompare;
      const spotCompare = this.transformSpot(a.spot).localeCompare(this.transformSpot(b.spot));
      if (spotCompare !== 0) return spotCompare;
    },
    validSearch(formOperationFilter) {
      let validDate = this.validateLimitDays(formOperationFilter);
      let validState = this.validateState(formOperationFilter);
      return validDate && validState;
    },
    validateState(formOperationFilter) {
      if (formOperationFilter.state.length > 0) {
        this.emptyState = false;
        return true;
      }
      this.emptyState = true;
      return false;
    },
    validateLimitDays(formOperationFilter) {
      if (formOperationFilter.date && formOperationFilter.date.start && formOperationFilter.date.end) {
        let validDate = false;
        let fecha1 = new Date(formOperationFilter.date.start);
        let fecha2 = new Date(formOperationFilter.date.end);
        let differenceDays = Math.abs(fecha2 - fecha1) / (1000 * 60 * 60 * 24);

        if (differenceDays > 31) {
          this.validDate = false;
        } else {
          this.validDate = true;
          validDate = true;
        }
        return validDate;
      } else {
        this.validDate = true;
        return true;
      }
    },
    transformDate(date) {
      if (date) {
        return moment(new Date(date)).format('DD-MM-YYYY');
      } else {
        return '-';
      }
    },
    transformSpot(spot) {
      return spot.address.street + ', ' + spot.address.city + ', ' + spot.address.state;
    },
    transformState(relation) {
      if (!relation) {
        relation = {
          idState: 'UNPLANNED',
        };
      }
      return this.$t(`planification.planificationBuilder.state['${relation.idState}']`);
    },
    cleanFormOperation() {
      this.formOperation.name = null;
      this.formOperation.address = null;
      this.formOperation.sender = null;
      this.formOperation.documents = null;
      (this.formOperation.tags = null),
        (this.formOperation.volume = null),
        (this.formOperation.weight = null),
        (this.formOperation.money = null),
        (this.formOperation.startHour = null),
        (this.formOperation.endHour = null),
        (this.formOperation.spotServiceTime = null),
        (this.formOperation.contact = null),
        (this.formOperation.phone = null),
        (this.formOperation.email = null);
    },
    loadOperationManual() {
      this.showLoadOperationMassive = false;
      this.showLoadOperationPending = false;
      this.showLoadOperationManual = true;
      this.showLoadOperationIntegration = false;
    },
    showOperationMassive() {
      this.showLoadOperationManual = false;
      this.showLoadOperationPending = false;
      this.showLoadOperationMassive = true;
      this.showLoadOperationIntegration = false;
    },
    showOperationPending() {
      this.cleanEmptyFiltersText();
      this.showLoadOperationManual = false;
      this.showLoadOperationMassive = false;
      this.showLoadOperationPending = true;
      this.showLoadOperationIntegration = false;
      this.requestOps();
    },
    showOperationIntegration() {
      this.cleanEmptyFiltersText();
      //Si solo hay una integración existente, entonces selecciono automaticamente la primera
      if (
        this.integrations.length == 1 &&
        this.formIntegrationOperation.integrations.length == 0 &&
        this.integrations.length > 0
      ) {
        this.formIntegrationOperation.integrations.push(this.integrations[0]);
      }
      if (this.formIntegrationOperation.integrations.length != 0) {
        this.isFilterApplied = true;
      }
      if (
        this.formIntegrationOperation.date &&
        this.formIntegrationOperation.date.start == null &&
        this.formIntegrationOperation.date.end == null
      ) {
        let endDate = new Date();
        endDate = endDate.setDate(endDate.getDate() - 14);
        this.formIntegrationOperation.date.start = moment(endDate).format('YYYY-MM-DD');
        this.formIntegrationOperation.date.end = moment(new Date()).format('YYYY-MM-DD');
      }
      this.showLoadOperationManual = false;
      this.showLoadOperationMassive = false;
      this.showLoadOperationPending = false;
      this.showLoadOperationIntegration = true;
      this.requestOpsIntegration();
    },
    cleanEmptyFiltersText() {
      this.emptyState = false;
      this.emptySearchDate = false;
      this.emptyIntegration = false;
    },
    showPopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::show::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    showPopoverBorderRed(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::hide::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
    openShowLoadExcel() {
      this.showLoadOperationManual = false;
      this.openExcel();
    },
    async deleteOperation(id) {
      this.isDeletePreparing = true;
      for (let i = this.operations.length - 1; i >= 0; i--) {
        if (this.planificationId && this.operations[i].idOperationJob === id) {
          const opsWStatus = await this.operationService.getStatusByPlanification(
            [this.operations[i].uuid],
            this.planificationId,
          );
          //Como pude presionar el boton de eliminar porque no estaba gestionada, es suficiente con validar que el estado entrante no sea notHandled
          if (opsWStatus[0].state !== 'NOTHANDLED') {
            this.operations[i].operationState = opsWStatus[0].state;
            this.filterOperation = null;
            showAlert(
              this.$t('common.modals.warning'),
              this.$t('planification.planificationBuilder.operation.invalidActionDelete'),
              'success',
            );
            this.emptyMassDeleteSelects();
            this.isDeletePreparing = false;
            return;
          }
        }
        if (this.operations[i].idOperationJob === id) {
          showConfirmation(
            this.$t('planification.planificationBuilder.modal.confirm'),
            this.$t('planification.planificationBuilder.modal.deleteConfirm', { name: this.operations[i].name }),
            async () => {
              // Si hay respuesta del optimizador
              if (this.planificationId) {
                // Busca en las unreachable si es que esta
                this.optimizationOutput.unreachableOperations.forEach((operation, index) => {
                  if (operation.uuid === this.operations[i].uuid) {
                    console.log('deleted from unreachable [', operation.name, ']');
                    this.optimizationOutput.unreachableOperations.splice(index, 1);
                  }
                });
              }
              this.deleteSpotWithIdOperation(this.operations[i]);
              await this.operations.splice(i, 1);
              this.emptyMassDeleteSelects();
              await this.applyFilter();
              return;
            },
            this.$t('common.cruds.aceptar'),
            this.$t('common.cruds.cerrar'),
          );
        }
      }
      this.isDeletePreparing = false;
    },
    emptyMassDeleteSelects() {
      this.checkedOperations = [];
      this.selectedAllOperations = false;
    },
    async editOperation(operation) {
      const bodyData = {
        gapi: this.gapi,
        planificationId: this.planificationId,
        tags: this.tags,
        senderList: this.senderList,
        itemNames: this.itemNames,
        mode: 'update',
      };
      if (typeof operation.typeOperation === 'string') {
        operation.typeOperation = this.typeOperationOptions.find(
          (operationType) => operationType.type == operation.typeOperation,
        );
      }
      showOperationDetail(
        bodyData,
        operation,
        this.operations,
        this.spotsTemporalData,
        this.distanceMatrixManual,
        (updateOperation) => {
          let index = this.operations.findIndex((op) => op.idOperationJob === updateOperation.idOperationJob);
          //Como actualice el listado completo de mis operaciones, debo actualizar la que se encarga de mostrar las operaciones en la tabla
          let indexFilter = this.operationsFilter.findIndex(
            (op) => op.idOperationJob === updateOperation.idOperationJob,
          );
          if (index >= 0) {
            Vue.set(this.operations, index, updateOperation);
          }
          if (indexFilter >= 0) {
            Vue.set(this.operationsFilter, indexFilter, updateOperation);
          }
        },
      );
    },
    openModal() {
      this.cancelado = false;
      this.$bvModal.show('addOpsPlanExist');
    },
    /**
     * Este metodo se encarga de cerrar el modal pero si hay datos sin guardar, entonces solicita confirmación
     */
    close(bmodal) {
      //Esto es para no entrar en un loop, por el modal de confirmacion
      if (this.forceClose) {
        // Reinicia la bandera y deja cerrar
        this.forceClose = false;
        return;
      }
      if (this.$refs.addOperations) {
        const formNameOp = this.$refs.addOperations.getNameFomForm();
        const formAddressOp = this.$refs.addOperations.getAddressFromForm();
        const fileMassOp = this.$refs.addOperations.getFileFromForm();
        if (formNameOp || formAddressOp || fileMassOp) {
          bmodal.preventDefault();
          showConfirmation(
            this.$t('planification.planificationBuilder.modal.operationEditModal.title'),
            this.$t('planification.planificationBuilder.modal.operationEditModal.body'),
            async () => {
              //Esto es para no entrar en un bucle al hacer hide
              this.forceClose = true;
              this.cancelado = true;
              //Esto es para que la carga masiva cancele sus consultas o la actualización de operaciones si es que cierro el modal justo en el proceso
              this.$refs.addOperations.$emit('cancelado-changed', this.cancelado);
              // Cerrar el modal
              this.$bvModal.hide('addOpsPlanExist');
            },
            this.$t('common.cruds.aceptar'),
            this.$t('common.cruds.cerrar'),
          );
        } else {
          this.$bvModal.hide('addOpsPlanExist');
        }
      } else {
        this.$bvModal.hide('addOpsPlanExist');
      }
    },
    async viewOperation(operation) {
      const bodyData = {
        gapi: this.gapi,
        planificationId: this.planificationId,
        tags: this.tags,
        senderList: this.senderList,
        itemNames: this.itemNames,
        mode: 'view',
      };
      if (typeof operation.typeOperation === 'string') {
        operation.typeOperation = this.typeOperationOptions.find(
          (operationType) => operationType.type == operation.typeOperation,
        );
      }
      showOperationDetail(
        bodyData,
        operation,
        this.operations,
        this.spotsTemporalData,
        this.distanceMatrixManual,
        () => {},
      );
    },
    async chooseDate() {
      const validResult = await this.validateOperations();
      if (validResult.isValid && validResult.isAddressValid) {
        this.processOperations();
      } else if (validResult.isValid && !validResult.isAddressValid) {
        showConfirmation(
          this.$t('common.modals.confirmacionTitulo'),
          this.$t('planification.planificationBuilder.modal.invalidAddress'),
          () => {
            this.processOperations();
          },
        );
      }
    },
    processOperations() {
      if (this.validatePlanificationName()) {
        if (this.operations.length > 0) {
          this.scrollToTop();
          this.logService.sendInfo({
            component: 'planificationBUilder',
            message: `processOperations viajando a la sección de fecha con un total de ${this.operations.length}`,
            data: {
              operations: this.operations,
            },
          });
          console.log('VAMOS A IR AL SIGUIENTE ESTADO ', this.distanceMatrixManual);
          this.$store.commit('setMetaData', {
            operations: this.operations,
            tags: this.tags,
            spotsTemporalData: this.spotsTemporalData,
            senderList: this.senderList,
            distanceMatrixManual: this.distanceMatrixManual,
            form: this.form,
            gapi: this.gapi,
          });
          this.$store.commit('setInputOptimization', this.optimizationInput);
          this.$store.commit('setOututOptimization', this.optimizationOutput);
          if (this.planificationId) {
            this.$router.push({
              name: 'DateAndDepotProcess',
              params: {
                planificationId: this.planificationId,
                planificationState: this.planificationState,
                planificationOngoing: this.planIsOngoing,
              },
            });
          } else {
            this.$router.push({
              name: 'DateAndDepotProcessNotOngoing',
              params: {
                planificationId: this.planificationId,
                planificationState: this.planificationState,
                planificationOngoing: this.planIsOngoing,
              },
            });
          }
          this.scrollToTop();
        } else {
          showAlert(
            this.$t('common.modals.errorTitulo'),
            this.$t('planification.planificationBuilder.validaciones.addOperations'),
            'error',
          );
        }
      }
    },
    getVehicleInfo(resource) {
      if (resource && resource.vehicle) {
        return resource.vehicle.plate;
      } else {
        return this.$t('planification.planificationBuilder.operation.resources.noVehicle');
      }
    },
    getDriverInfo(resource) {
      if (resource && resource.driver) {
        return resource.driver.driverName;
      } else {
        return this.$t('planification.planificationBuilder.operation.resources.noDriver');
      }
    },
    getRouteInfo(route) {
      if (route) {
        return route;
      } else {
        return this.$t('planification.planificationBuilder.operation.resources.noRoute');
      }
    },
    validatePlanificationName() {
      if (this.form.planificationName != null && this.form.planificationName) {
        return true;
      }
      this.showPopover('fldNombre');
      return false;
    },
    //Esto se encarga de actualizar las variables que filtran el listado de operaciones, asi se puede usar los botones de busqueda a nivel de front
    async applyFilter() {
      this.isMainPageBussy = true;
      await this.$nextTick(); // le das tiempo al DOM a reflejar el estado ocupado
      this.filterOperation = this.filterOperationTemp;
      this.filterDrivers = this.filterDriversTemp;
      this.filterTypeOperation = this.filterTypeOperationTemp;
      this.filterVehicles = this.filterVehiclesTemp;
      this.filterOperationState = this.filterOperationStateTemp;
      const filterText = this.filterOperation?.toUpperCase();
      const translatedNoDriver = this.$t(
        'planification.planificationBuilder.operation.resources.noDriver',
      ).toLowerCase();
      const translatedNoVehicle = this.$t(
        'planification.planificationBuilder.operation.resources.noVehicle',
      ).toLowerCase();
      this.operationsFilter = this.operations.filter((op) => {
        // Cualquier texto añadido en el input
        if (this.filterOperation) {
          const name = op.name?.toUpperCase() || '';
          const address = op.address?.toUpperCase() || '';
          if (!name.includes(filterText) && !address.includes(filterText)) return false;
        }
        //Filtramos segun los estados de la operacion seleccionados en el filtro
        if (this.filterTypeOperation && this.filterTypeOperation.length > 0) {
          if (!this.filterTypeOperation.some((d) => d.type === op.typeOperation.type)) return false;
        }
        //Filtramos segun los vehiculos seleccionados en el filtro
        if (this.filterVehicles && this.filterVehicles.length > 0) {
          const plate = this.getVehicleInfo(op.resource).toLowerCase();
          const matchesVehicle = this.filterVehicles.some((filter) =>
            filter.key === 'noVehicle' ? plate?.includes(translatedNoVehicle) : plate === filter.key.toLowerCase(),
          );
          if (!matchesVehicle) return false;
        }

        //Filtramos segun los conductores seleccionados en el filtro
        if (this.filterDrivers && this.filterDrivers.length > 0) {
          const driverName = this.getDriverInfo(op.resource).toLowerCase();
          const matchesDriver = this.filterDrivers.some((filter) =>
            filter.key === 'noDriver'
              ? driverName?.includes(translatedNoDriver)
              : driverName === filter.key.toLowerCase(),
          );
          if (!matchesDriver) return false;
        }

        //Filtramos segun los estados de la operacion seleccionados en el filtro
        if (this.filterOperationState && this.filterOperationState.length > 0) {
          if (!this.filterOperationState.some((d) => d.key === op.operationState)) return false;
        }

        return true; // pasa todos los filtros
      });
      this.isMainPageBussy = false;
    },
    //Metodo que dirige a la parte superior de la pantalla, hace un scroll to top pero al elemento que esta arriba
    scrollToTop() {
      const topElement = document.getElementById('topElement');
      topElement.scrollIntoView({ behavior: 'smooth' });
    },
    handleClickOutside(event) {
      const child = this.$refs.addOperations?.$el;
      if (child && !child.contains(event.target)) {
        this.toogleFilter();
      }
      //Caso en el cual entro en modo edicion de planificación y debo gestionar el filtro de ahi
      else if (!child) {
        this.toogleFilter();
      }
    },
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.$refs.addOperations) {
        this.$refs.addOperations.toogleFilter();
      }
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    getOperationTypeInfo(operationType) {
      const typeKey = operationType === 'COLLECTION' ? 'collection' : 'delivery';
      return this.$t(`planification.operationType.${typeKey}`);
    },
  },
  computed: {
    operationsFilterComputed() {
      this.currentSortBy = null;
      const filtered = this.operationsFilter
        .map((op) => {
          const route = this.getRouteInfo(op.route);
          const driverName = this.getDriverInfo(op.resource);
          const vehiclePlate = this.getVehicleInfo(op.resource);
          const typeOperation = this.getOperationTypeInfo(op.typeOperation.type);
          const driverId = op.resource?.driver ? op.resource.driver?.id : null;
          const vehicle = op.resource?.vehicle ? op.resource.vehicle : null;
          return {
            ...op,
            operationState: op.operationState,
            typeOperation: op.typeOperation,
            nameTypeOperation: typeOperation,
            route,
            resource: {
              driver: {
                id: driverId,
                driverName,
              },
              vehicle: {
                id: vehicle?.id || null,
                plate: vehiclePlate,
                idVehicleOperaciones: vehicle?.idVehicleOperaciones || null,
              },
            },
          };
        })
        .sort((a, b) => this.sortRules(a, b));
      return filtered;
    },
    itemOperationTypes() {
      const typeOperation = this.typeOperationOptions.map((type) => ({
        name: this.getOperationTypeInfo(type.type),
        type: type.type,
      }));
      return typeOperation;
    },
    itemVehicles() {
      const uniqueVehicles = new Set(
        this.operations.map((op) => op.resource?.vehicle?.plate).filter((plate) => plate != null), // filtra nulos o undefined
      );
      const vehicles = Array.from(uniqueVehicles).map((vehicle) => ({
        name: vehicle,
        key: vehicle,
      }));
      return [
        ...vehicles,
        {
          name: this.$t('planification.planificationBuilder.operation.resources.noVehicle'),
          key: 'noVehicle',
        },
      ];
    },
    itemDrivers() {
      const uniqueDrivers = new Set(
        this.operations.map((op) => op.resource?.driver?.driverName).filter((driverName) => driverName != null), // filtra nulos o undefined
      );
      const drivers = Array.from(uniqueDrivers).map((driver) => ({
        name: driver,
        key: driver,
      }));
      return [
        ...drivers,
        {
          name: this.$t('planification.planificationBuilder.operation.resources.noDriver'),
          key: 'noDriver',
        },
      ];
    },
    itemStates() {
      const states = [
        {
          name: this.$t('planification.states.operation.DONE'),
          key: 'ENDOPERATIONDONE',
        },
        {
          name: this.$t('planification.states.operation.PARTIALLYDONE'),
          key: 'ENDOPERATIONPARTIALLYDONE',
        },
        {
          name: this.$t('planification.states.operation.REJECTED'),
          key: 'ENDOPERATIONREJECTED',
        },
        {
          name: this.$t('planification.states.operation.NOTDONE'),
          key: 'NOTHANDLED',
        },
      ];
      return states;
    },
    jsonData() {
      return this.$store.getters.jsonDataPlanification || {};
    },
    operationsFields() {
      const common = {
        class: 'text-left',
        tdClass: 'small',
      };
      const fields = [
        {
          key: 'select',
          label: '',
        },
        {
          key: 'routeIcon',
          label: this.$t('planification.planificationBuilder.operation.fields.tableAlert'),
        },
        {
          key: 'name',
          label: this.$t('planification.planificationBuilder.operation.fields.tableName'),
          sortable: true,
        },
        this.planificationId != null
          ? {
              key: 'nameTypeOperation',
              label: this.$t('planification.planificationBuilder.operation.fieldType'),
              sortable: true,
            }
          : null,
        this.planificationId != null
          ? {
              key: 'resource.vehicle.plate',
              label: this.$t('planification.planificationBuilder.operation.fields.tableVehicle'),
              sortable: true,
            }
          : null,
        this.planificationId != null
          ? {
              key: 'resource.driver.driverName',
              label: this.$t('planification.planificationBuilder.operation.fields.tableDriver'),
              sortable: true,
            }
          : null,
        {
          key: 'address',
          label: this.$t('planification.planificationBuilder.operation.fields.tableAddress'),
          sortable: true,
        },
        this.planificationId != null
          ? {
              key: 'operationState',
              label: this.$t('planification.planificationBuilder.operation.fields.tableState'),
              sortable: true,
            }
          : null,
        {
          key: 'actions',
          label: this.$t('planification.planificationBuilder.operation.actions'),
        },
      ]
        .filter(Boolean) // Elimina los `null` cuando planificationId no existe
        .map((field) => ({ ...field, ...common }));

      return fields;
    },
    operationPendingField() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'name',
          label: this.$t('planification.planificationBuilder.table.name'),
          ...common,
        },
        {
          key: 'spot',
          label: this.$t('planification.planificationBuilder.table.spot'),
          ...common,
        },
        {
          key: 'relation',
          label: this.$t('planification.planificationBuilder.table.state'),
          ...common,
        },
        {
          key: 'motive',
          label: this.$t('planification.planificationBuilder.table.motive'),
          ...common,
        },
        {
          key: 'subMotive',
          label: this.$t('planification.planificationBuilder.table.submotive'),
          ...common,
        },
      ];
    },
    operationIntegrationField() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'name',
          label: this.$t('planification.planificationBuilder.table.name'),
          ...common,
        },
        {
          key: 'integration',
          label: this.$t('planification.planificationBuilder.table.integration'),
          ...common,
        },
        {
          key: 'spot',
          label: this.$t('planification.planificationBuilder.table.spot'),
          ...common,
        },
        {
          key: 'createdAt',
          label: this.$t('planification.planificationBuilder.table.date'),
          ...common,
        },
        {
          key: 'action',
          label: this.$t('planification.planificationBuilder.table.actions'),
          ...common,
        },
      ];
    },
  },
};
